export function addMessageToDebugConsole (data) {
  const { key = 'uncatched-error', title = 'Uncatched error', message, type = 'error' } = data
  window[Symbol.for('vue.instance')]
    .$emit('update-debugger-console-data', { key, title, message, type })
}
